import React, { useState, useEffect, useRef } from 'react'
import "./PrintClinicalSummaryView.scss"
import { generateClinicalSummary } from 'core/services/api/patientDiagnosisService'
import fileUtils from "fileUtils"
import Toast from "../../components/Toast"
import Print from 'components/Print/Print'

export default function ClinicalSummaryView({ patient, appointmentDetails, scroll }: any) {
  const componentRef = useRef<any>(null)
  const [htmlPdf, setHtml] = useState<any>()
  const [urlPdfDownload, setUrlDownload] = useState<any>()
  const [isSuccess, setIsSuccess] = useState<any>(false)
  const [isFailure, setIsFailure] = useState<any>(false)
  const [urlPresent, setUrlPresent] = useState<any>(false)
  const appointmentId = appointmentDetails?.id;
  const divClinicalRef = useRef<any>(null)

  useEffect(() => {
    if (scroll) {
      scroll()
    }
  }, [])

  const getUrlPdf = () => {
    if (appointmentId) {
      generateClinicalSummary(appointmentId, true, false, false)
        .then((res: any) => {
          setHtml(res)
        })
        .catch((err: any) => {
          console.log(err?.message)
        })
    }
  }

  const getUrlPdfDownload = () => {
    if (appointmentId) {
      generateClinicalSummary(appointmentId, false, false, true, true)
        .then((res: any) => {
          const { url } = res
          setUrlDownload(url)
          setUrlPresent(true)
        })
        .catch((err: any) => {
          console.log(err?.message)
        })
    }
  }

  useEffect(() => {
    if (htmlPdf) {
      divClinicalRef.current.innerHTML = htmlPdf;
    }
  }, [htmlPdf]);

  const handleClinicalSummaryDownload = () => {
    if (urlPdfDownload) {
      fileUtils.downloadFileViaUrl(urlPdfDownload, `Clinical_Summary_${patient}.pdf`)
      setIsSuccess(true)
    } else {
      setIsFailure(true)
    }
  }

  useEffect(() => {
    getUrlPdf()
    setTimeout(() => {
      getUrlPdfDownload()
    }, 3500)
  }, [appointmentId])

  return (
    <div className='clinical-summary-print'>
      {isSuccess ? (
        <Toast
          textMessage={"Clinical Summary Downloaded Successfully"}
          type="success"
          onCloseText={"Close"}
          onClose={() => setIsSuccess(false)}
        />
      ) : isFailure ? (
        <Toast
          textMessage={"Patient diagnosis is empty, failed to generate clinical summary"}
          type="error"
          onCloseText={"Close"}
          onClose={() => setIsFailure(false)}
        />
      ) : null}
      {htmlPdf && (
        <div>
          <div className={`print-download-icon ${appointmentDetails?.appointmentType === "IPD" ? 'print-download-margin' : ''} ${urlPresent ? '' : 'waiting-cursor'}`} >
            {urlPresent ? (
              <>
                <Print componentRef={componentRef} />
              </>
            ) : (
              <img
                src="../../assets/images/Group7951.svg"
                height={"25px"}
                width={"35px"}
                className="cursor-pointer waiting-cursor"
                alt="print button"
              />
            )}
            <img
              src="../../assets/images/Group990.svg"
              height={"25px"}
              width={"35px"}
              className={`${urlPresent ? 'cursor-pointer' : 'cursor-pointer waiting-cursor'}`}
              alt="download button"
              onClick={() => {
                if (urlPresent) {
                  handleClinicalSummaryDownload()
                }
              }}
            />
          </div>
          <div ref={componentRef} id="printId">
            <div ref={divClinicalRef} className="view-contents"></div>
          </div>
        </div>
      )}
    </div>
  )
}
